export default "__VITE_ASSET__RY3DpXPG__"